/*
 * What every signed-out page app needs from its page.
 */
import { api } from '@admin/helpers.js';

/** What the view put on the mount element: <div id="..." data-config='{...}'>. */
export function mountConfig(selector) {
    const el = document.querySelector(selector);
    try {
        return JSON.parse((el && el.dataset.config) || '{}') || {};
    } catch (e) {
        return {};
    }
}

/** The site address with a trailing slash, from the page's config. */
export function siteUrl(config) {
    const url = String((config && config.homeUrl) || '/');
    return url.endsWith('/') ? url : url + '/';
}

/**
 * A form-encoded POST to one of the portal's own endpoints, as $.post sent it.
 * Always answers an object: what is not a JSON object (an error page, an
 * empty answer) becomes { status: false }.
 */
export async function post(config, path, data) {
    const result = await api.postForm(siteUrl(config) + path, data);
    return (result && typeof result === 'object') ? result : { status: false };
}

/** The nonce for the Google button (renderGoogleButton): asked for each time the button is drawn. */
export async function googleNonce(config) {
    const result = await post(config, 'auth/ajax/google_nonce', {});
    return result.status ? String(result.nonce || '') : '';
}
